import ResizableBox from "./ResizableBox";
import useDemoConfig from "./useDemoConfig";
import React from "react";
import { Bar } from "react-chartjs-2";
import { Paper, Grid, Tooltip, IconButton, Typography, Toolbar, Theme } from "@mui/material";

import makeStyles from '@mui/styles/makeStyles';
import { MoreVertRounded } from "@mui/icons-material";

import { gray1, lighestGray, strongGray, boxDefaultBG, boxDefaultBorder } from "../DashStyleGuides";
const data = {
  labels: ["1", "2", "3", "4", "5", "6"],
  datasets: [
    {
      label: "Product 1",
      data: [12, 19, 3, 5, 2, 3],
      backgroundColor: "rgb(255, 99, 132)",
    },
    {
      label: "Product 2",
      data: [2, 3, 20, 5, 1, 4],
      backgroundColor: "rgb(54, 162, 235)",
    },
    {
      label: "Product 3",
      data: [3, 10, 13, 15, 22, 30],
      backgroundColor: "rgb(75, 192, 192)",
    },
    {
      label: "Product 4",
      data: [6, 12, 8, 19, 32, 8],
      backgroundColor: "#3F6280",
    },
  ],
};

const options = {
  maintainAspectRatio: false,
  scales: {
    y: {
      stacked: true,
      ticks: {
        beginAtZero: true,
      },
    },
    x: {
      stacked: true,
    },
  },
};

// Styling
const useStyles = makeStyles((theme: Theme) => ({
  root: {
    height: 350,
    border: `1px solid ${boxDefaultBorder}`,
    background: boxDefaultBG,
  },
  title: {
    flex: "1 1 100%",
    fontSize: 14,
    fontWeight: 700,
    color: strongGray,
  },
  tblRoot: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
    height: 34,
    background: lighestGray,
    borderBottom: `1px solid ${gray1}`,
  },
}));

export default function DamagesGraph() {
  const classes = useStyles();

  return (
    <>
      <Grid item sm={12}>
        <Paper className={classes.root}>
          <Toolbar className={classes.tblRoot} variant="dense">
            <Typography className={classes.title} color="textSecondary">
              Analytics
            </Typography>

            {/* <Tooltip title="More options">
              <IconButton aria-label="More options">
                <MoreVertRounded />
              </IconButton>
            </Tooltip> */}
          </Toolbar>

          <div
            className="chart-container"
            style={{
              position: "relative",
              height: 280,
              margin: 15,
            }}
          >
            {/* @ts-ignore */}
            <Bar data={data} options={options} />
          </div>
        </Paper>
      </Grid>
    </>
  );
}
